import { render, staticRenderFns } from "./CopyrightsAndTariffs.vue?vue&type=template&id=ba568bc2&scoped=true&"
import script from "./CopyrightsAndTariffs.vue?vue&type=script&lang=js&"
export * from "./CopyrightsAndTariffs.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightsAndTariffs.vue?vue&type=style&index=0&id=ba568bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba568bc2",
  null
  
)

export default component.exports